module.exports = __webpack_public_path__ + "static/media/apn_badge.8dfe1531.svg";